import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import ActionBar from '../components/ActionBar';
import Tabber from '../components/Tabber';
import Stack from '@mui/material/Stack';
import TabberPanel from '../components/TabberPanel';
import { useNavigate } from 'react-router-dom';
import ActivitiesGrid from 'features/Activity/ActivitiesGrid';
import UnitsGrid from 'features/Unit/UnitsGrid';
import { PermissionFilter  } from '@timmons-group/shared-react-components';
import { ACLS } from 'constants';
import { hasPermission } from '../helpers';
import { useAuth } from '@timmons-group/shared-react-components/hooks';

// Tabs are defined here for the sub header
const tabs = [{ index: 0, label: 'Units', path: 'units' },
  { index: 1, label: 'All Activities', path: 'activities', pathSegment: 'all', layoutKey:'activityList' },
  { index: 2, label: 'Planned Activities', path: 'planned_activities', pathSegment:'planned', layoutKey:'plannedActivityList' }];

// Main component
const Search = ({initialTabIndex}) => {
  const [tabIndex, setTabIndex] = React.useState(initialTabIndex || 0);
  const nav = useNavigate();
  const { authState } = useAuth();
  const userAcl = authState?.user?.acl;

  let viewableTabs = tabs;
  if (!hasPermission(ACLS.SEE_ACTIVITIES, userAcl)) {
    viewableTabs = [tabs[0]];
  }

  // Function for handling the tab change
  const handleChange = (newValue) => {
    setTabIndex(newValue);
    nav(`/search/${tabs[newValue].path.toLowerCase()}`);
  };

  return (
    <>

      {/* 🚀 Sub header action bar */}
      <ActionBar
        leftRender={
          () =>
            <Stack spacing={2} direction="row" justifyContent="flex-start">
              <Tabber
                index={tabIndex}
                tabs={viewableTabs}
                onChange={handleChange}
              />
            </Stack>
        }
        rightRender={
          () => <div />
        }
      />

      {/* 🌏 Main content */}
      <Box px={7}>
        <Container maxWidth={false} sx={{ marginTop: 2 }}>
          <Card>
            <TabberPanel value={tabIndex} index={0}>
              {
                (tabIndex === 0) ?
                  <UnitsGrid />
                  : <></>
              }
            </TabberPanel>
            <PermissionFilter permission={ACLS.SEE_ACTIVITIES}>
              <TabberPanel value={tabIndex} index={1}>
                {
                  (tabIndex === 1) ?
                    <ActivitiesGrid
                      pathSegment={tabs[tabIndex].pathSegment}
                      layoutKey={tabs[tabIndex].layoutKey}
                    />
                    : <></>
                }
              </TabberPanel>
            </PermissionFilter>
            <PermissionFilter permission={ACLS.SEE_ACTIVITIES}>
              <TabberPanel value={tabIndex} index={2}>
                {
                  (tabIndex === 2) ?
                    <ActivitiesGrid
                      pathSegment={tabs[tabIndex].pathSegment}
                      layoutKey={tabs[tabIndex].layoutKey}
                    />
                    : <></>
                }
              </TabberPanel>
            </PermissionFilter>
          </Card>
        </Container>
      </Box>
    </>
  );
}

Search.propTypes = {
  initialTabIndex: PropTypes.number,
}

export default Search;
